import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVICE_TAG_TYPES } from "./Constants";
import { getAccessToken } from "./Functions";

const baseUrl = `${import.meta.env.VITE_ASKAMI_API_BASE_URL}`;

export const baseAPI = createApi({
  reducerPath: "baseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: async (headers) => {
      const token = await getAccessToken();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Ocp-Apim-Subscription-Key", import.meta.env.VITE_SUBSCRIPTION_KEY ?? "");
      headers.set("Content-Type", "application/json");
      headers.set("Strict-Transport-Security", "max-age=3600 ; includeSubDomains");
      headers.set("Accept", "*/*");
      headers.set("Accept-Encoding", "gzip, deflate, br");
      headers.set("Connection", "keep-alive");

      return headers;
    },
  }),
  tagTypes: Object.values(SERVICE_TAG_TYPES),
  endpoints: () => ({}),
});
